import { ref } from 'vue'

// Mesmo padrão de useGlobalSearch.ts/useShortcutsHelp.ts — estado de módulo pra
// App.vue (atalho de tecla K) e o próprio modal compartilharem sem prop drilling.
export const broadcastComposeOpen = ref(false)

export function openBroadcastCompose()  { broadcastComposeOpen.value = true }
export function closeBroadcastCompose() { broadcastComposeOpen.value = false }
